import styled, { DefaultTheme } from 'styled-components'

export const StyledTitle = styled.h5`
  text-align: center;
  color: ${({ theme }: { theme: DefaultTheme }) => theme.color.twine};
`
